// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RpcApiResponse } from '@interfaces/api.interfaces';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RequestService {
    constructor(private readonly httpClient: HttpClient) {}

    get$<T>(path: string, bearerToken: string = null, additionalOptions: object = {}): Observable<RpcApiResponse<T>> {
        return this.httpClient.get<RpcApiResponse<T>>(this.buildUri(path), this.buildOptions(bearerToken, additionalOptions));
    }

    post$<T>(path: string, body: object, bearerToken: string = null, additionalOptions: object = {}): Observable<RpcApiResponse<T>> {
        return this.httpClient.post<RpcApiResponse<T>>(this.buildUri(path), body, this.buildOptions(bearerToken, additionalOptions));
    }

    put$<T>(path: string, body: object, bearerToken: string = null, additionalOptions: object = {}): Observable<RpcApiResponse<T>> {
        return this.httpClient.put<T>(this.buildUri(path), body, this.buildOptions(bearerToken, additionalOptions));
    }

    delete$<T>(path: string, bearerToken: string = null, additionalOptions: object = {}): Observable<RpcApiResponse<T>> {
        return this.httpClient.delete<RpcApiResponse<T>>(this.buildUri(path), this.buildOptions(bearerToken, additionalOptions));
    }

    private buildOptions(jwt: string, opts?: object): object {
        const options = opts || {};
        if (jwt) {
            if (!('headers' in options) || !options['headers']) {
                options['headers'] = {};
            }
            options['headers']['Authorization'] = 'Bearer ' + jwt;
        }
        return options;
    }

    private buildUri(path: string): string {
        // if the path already knows where it wants to go, make no changes
        if (path.startsWith('http')) {
            return path;
        }

        // otherwise, prefix the api root
        return environment.apiUrlV2 + path;
    }
}
